import Api from './Api'

export default {
    get(keyword, pageNumber, pageSize, order) {
        return Api().get(`period?keyword=${keyword}&pageNumber=${pageNumber}&pageSize=${pageSize}&orderColumn=${order.column}&orderSort=${order.sort}`);
    },
    getAll() {
        return Api().get('period/all');
    },
    getOne(id) {
        return Api().get(`period/${id}`);
    },
    getActivePeriod() {
        return Api().get(`period/getLatestActivePeriod`);
    },
    create(data) {
        return Api().post(`period`, data);
    },
    update(data) {
        return Api().put(`period/${data.id}`, data);
    }
}